import { SelectOption, useFetch } from 'common.ui';
import { applicationsClient } from 'api/AdgangClients';

export function useApplicationResponsibles(): [SelectOption[] | undefined] {
  const loadUsers = async (): Promise<SelectOption[]> => {
    const response = await applicationsClient.apiApplicationsApplicationResponsiblePersonsCandidatesGet();
    const items = response || [];

    return items
      .sort((u1, u2) => (u1.name || '').localeCompare(u2.name || ''))
      .map((u) => {
        return {
          id: u.userId,
          text: u.name
        } as SelectOption;
      });
  };

  const [applicationResponsibles] = useFetch<SelectOption[] | undefined>(loadUsers, undefined);

  return [applicationResponsibles];
}
